import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import './config/amplifyAuth';
import { getRumRuntimeConfig } from './config/rumConfig';
import { recordErrorStage, recordFunnelStep } from './utils/rum';

const rumRuntimeConfig = getRumRuntimeConfig();

// Initialize AWS CloudWatch RUM when build-time env is configured.
if (rumRuntimeConfig) {
  try {
    const config: AwsRumConfig = {
      sessionSampleRate: rumRuntimeConfig.sessionSampleRate,
      endpoint: rumRuntimeConfig.endpoint,
      telemetries: rumRuntimeConfig.telemetries,
      allowCookies: rumRuntimeConfig.allowCookies,
      enableXRay: rumRuntimeConfig.enableXRay,
      signing: rumRuntimeConfig.signing,
    };

    const awsRum: AwsRum = new AwsRum(
      rumRuntimeConfig.applicationId,
      rumRuntimeConfig.applicationVersion,
      rumRuntimeConfig.region,
      config
    );

    (window as any).awsRum = awsRum;
    recordFunnelStep('rum_init', 'success', {
      app_region: rumRuntimeConfig.region,
    });
  } catch (error) {
    console.error('Error initializing CloudWatch RUM:', error);
    recordFunnelStep('rum_init', 'failure');
    recordErrorStage('rum_init', error);
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
